import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Demo from "@/pages/Demo";
import About from "@/pages/About";
import Partners from "@/pages/Partners";
import Blog from "@/pages/Blog";
import IntegrationsCatalog from "@/pages/IntegrationsCatalog";
import Terms from "@/pages/Terms";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Onboarding from "@/pages/Onboarding";
import AcceptInvite from "@/pages/AcceptInvite";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/app/Dashboard";
import Cards from "@/pages/app/Cards";
import CardDetail from "@/pages/app/CardDetail";
import Integrations from "@/pages/app/Integrations";
import Team from "@/pages/app/Team";
import Billing from "@/pages/app/Billing";
import BillingSuccess from "@/pages/app/BillingSuccess";
import ApiKeys from "@/pages/app/ApiKeys";
import KnowledgeBase from "@/pages/app/KnowledgeBase";
import Bridge from "@/pages/app/Bridge";
import Squads from "@/pages/app/Squads";
import AdminPanel from "@/pages/app/AdminPanel";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/about" element={<About />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/integrations" element={<IntegrationsCatalog />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/accept-invite/:token" element={<AcceptInvite />} />
          {/* Authenticated */}
          <Route element={<ProtectedRoute />}>
            <Route path="/onboarding" element={<Onboarding />} />
            <Route element={<AppLayout />}>
              <Route path="/app" element={<Dashboard />} />
              <Route path="/app/cards" element={<Cards />} />
              <Route path="/app/cards/:id" element={<CardDetail />} />
              <Route path="/app/integrations" element={<Integrations />} />
              <Route path="/app/team" element={<Team />} />
              <Route path="/app/billing" element={<Billing />} />
              <Route path="/app/billing/success" element={<BillingSuccess />} />
              <Route path="/app/api-keys" element={<ApiKeys />} />
              <Route path="/app/knowledge" element={<KnowledgeBase />} />
              <Route path="/app/bridge" element={<Bridge />} />
              <Route path="/app/squads" element={<Squads />} />
              <Route path="/app/admin" element={<AdminPanel />} />
            </Route>
          </Route>
        </Routes>
        <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
